import { addHours } from 'date-fns'
import storeFactory from '@/helpers/storeFactory'
import orderBy from 'lodash.orderby'

export default storeFactory({
  model: {
    event_uuid: null,
    type: null,
    deviation_type: null,
    train_number: null,
    from: null,
    to: null,
    departure_date: new Date(),
    departure: new Date(),
    arrival: addHours(new Date(), 1)
  },
  state: {
    places: []
  },
  getters: {
    advertisedPlaces(state) {
      return orderBy(
        state.places.map(x => {
          return {
            short_name: x.location,
            stop_name: x.location_long_name
          }
        }),
        ['advertised'],
        ['asc']
      )
    },

    departurePlaces(state) {
      return orderBy(
        state.places
          .filter(x => x.type === 'Avgang')
          .map(x => {
            return {
              advertised: x.advertised,
              short_name: x.location,
              stop_name: x.location_long_name,
              _key: `${x.location}_${x.advertised}`
            }
          }),
        ['advertised'],
        ['asc']
      )
    },

    arrivalPlaces(state) {
      return orderBy(
        state.places
          .filter(x => x.type === 'Ankomst')
          .map(x => {
            return {
              advertised: x.advertised,
              short_name: x.location,
              stop_name: x.location_long_name,
              _key: `${x.location}_${x.advertised}`
            }
          }),
        ['advertised'],
        ['asc']
      )
    },

    newItems(state, _, rootState) {
      const trafficMessageModel = rootState.trafficMessage.model

      const train_deviations = [
        ...new Set([...(trafficMessageModel?.train_deviations || [])])
      ]

      const checkedItems = Object.values(state.data).filter(
        x => x.checked && !x.deleted
      )

      return checkedItems.filter(x => !train_deviations.includes(x.uuid))
    },

    missingItems(state, _, rootState) {
      const trafficMessageModel = rootState.trafficMessage.model

      const train_deviations = [
        ...new Set([...(trafficMessageModel?.train_deviations || [])])
      ]

      const missingItems = train_deviations
        .filter(uuid => state.data[uuid] && !state.data[uuid].checked)
        .map(x => state.data[x])

      return missingItems
    },

    newItemsCount(state, getters) {
      return getters['newItems'].length
    },

    missingItemsCount(state, getters) {
      return getters['missingItems'].length
    },

    diffItemsCount(state, getters) {
      return getters['newItemsCount'] + getters['missingItemsCount']
    },

    diffItemsCountTrainDeviation(state, getters) {
      return (
        getters['newItems'].filter(x => x.deviation_type !== 'CANCELED_STOP')
          .length +
        getters['missingItems'].filter(
          x => x.deviation_type !== 'CANCELED_STOP'
        ).length
      )
    },

    diffItemsCountRejectedStop(state, getters) {
      return (
        getters['newItems'].filter(x => x.deviation_type === 'CANCELED_STOP')
          .length +
        getters['missingItems'].filter(
          x => x.deviation_type === 'CANCELED_STOP'
        ).length
      )
    }
  }
})
